import React from 'react';
import '../assets/styles/Contact.scss';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';

function Contact() {

  return (
    <div id="contact">
      <div className="items-container">
        <div className="contact_wrapper">
          <h1>Contact Me</h1>
          <p>Got a project waiting to be realized? Let's collaborate and make it happen!</p>
          <div className="contact-details">
            <p><strong>Location:</strong> Malappuram, Kerala, India</p>
            <p><strong>Phone:</strong> +91 96451 63968</p>
            <p><strong>Email:</strong> <a href="mailto:farshini5@gmail.com">farshini5@gmail.com</a></p>
            <p><strong>LinkedIn:</strong> <a href="https://www.linkedin.com/in/farshini-dev" target="_blank" rel="noreferrer">linkedin.com/in/farshini-dev</a></p>
            <p><strong>GitHub:</strong> <a href="https://github.com/Farshini" target="_blank" rel="noreferrer">github.com/Farshini</a></p>
            <p><strong>Availability:</strong> Immediate Joiner — 4+ Years Experience</p>
          </div>
          <Box className="company-contact contact-form">
            <h2>Hiring / Recruitment</h2>
            <p>I am currently open for full-time opportunities. I have 4+ years of experience building scalable web applications, RESTful APIs, and administration platforms using Laravel, Next.js, React, PostgreSQL, and MySQL.</p>
            <div className="contact-cta">
              <Button variant="contained" startIcon={<SendIcon />} component="a" href="mailto:farshini5@gmail.com?subject=Opportunity%20Inquiry">Email Me</Button>
              <Button variant="outlined" component="a" href="/Farshini%20CK%20Full%20Stack%20Developer.pdf" target="_blank" rel="noreferrer" aria-label="Download resume" download="Farshini-Resume.pdf">Download Resume</Button>
              <Button variant="outlined" component="a" href="https://www.linkedin.com/in/farshini-dev" target="_blank" rel="noreferrer">View LinkedIn</Button>
            </div>
            <div className="company-details">
              <p><strong>Role:</strong> Senior Full Stack Developer (Immediate Joiner)</p>
              <p><strong>Location:</strong> Malappuram, Kerala, India</p>
              <p><strong>Phone:</strong> +91 96451 63968</p>
              <p><strong>Email:</strong> <a href="mailto:farshini5@gmail.com">farshini5@gmail.com</a></p>
            </div>
            {/* <p className="note">Resume available at <code>/Farshini CK Full Stack Developer.pdf</code> in the `public/` folder — clicking <em>Download Resume</em> will download the PDF (saved as <code>Farshini-Resume.pdf</code>).</p> */}
          </Box>
        </div>
      </div>
    </div>
  );
}

export default Contact;